import {
  INTAKE_QUESTIONS as questions,
  SELLER_REASON_LABELS as reasons,
} from "./intake-copy";

/** Plain-language defaults are available before a form’s translation cache fills. */
export const INTAKE_COPY_SPANISH: Record<string, string> = {
  [questions.full_name.label]: "Tu nombre",
  [questions.email.label]: "Correo electrónico",
  [questions.email.description]:
    "Tu correo te permite guardar tu progreso y acceder a tu portal.",
  [questions.phone.label]: "Número de teléfono",
  [questions.ownership_duration.label]:
    "¿Cuánto tiempo llevas siendo dueño del negocio?",
  [questions.annual_revenue.label]:
    "¿Cuánto vendió tu negocio en los últimos 12 meses?",
  [questions.annual_revenue.description]:
    "Antes de gastos. Una cifra aproximada está bien.",
  [questions.sell_motivation.label]: "¿Qué te hace pensar en vender?",
  [questions.sell_motivation.description]:
    "Elige todas las opciones que correspondan.",
  [questions.seller_timeline.label]: "¿Cuándo te gustaría vender tu negocio?",
  [questions.contact_preference.label]:
    "¿Cómo te gustaría que {First} te contactara?",
  [questions.budget_range.label]: "¿Cuánto te gustaría gastar en un negocio?",
  [questions.budget_range.description]:
    "El precio total, incluido lo que planeas pedir prestado.",
  [questions.buyer_timeline.label]: "¿Cuándo te gustaría comprar un negocio?",
  [questions.buyer_experience.label]: "¿Has sido dueño de un negocio antes?",
  [questions.industries_of_interest.label]:
    "¿Qué tipos de negocios te interesan?",
  [questions.industries_of_interest.description]:
    "Elige los que te interesen o salta esta pregunta por ahora.",
  [reasons.considering_retirement]:
    "Estoy pensando en jubilarme o trabajar menos",
  [reasons.received_offer]: "Un posible comprador me contactó",
  [reasons.exploring_liquidity]: "Me gustaría vender parte del negocio",
  [reasons.planning_transition]:
    "Estoy planeando que alguien más se haga cargo",
  [reasons.just_curious]: "Tengo curiosidad por conocer mis opciones",
  "I buy or invest in businesses": "Compro negocios o invierto en ellos",
  "I’ve owned a business before": "He sido dueño de un negocio antes",
  "This would be my first business": "Este sería mi primer negocio",
};
